import styled from 'styled-components';

export const Button = styled.div`
position: fixed;
width: 100%;
left: 95%;
top: 85%;
bottom: 40px;
height: 20px;
font-size: 3rem;
z-index: 1;
cursor: pointer;
color: #1e978c;
&:hover{
    color: teal;
}
@media only screen and (max-width: 1024px) {
    left: 93%;
    top: 85%;
}
@media only screen and (max-width: 768px) {
    left: 90%;
    top: 90%;
}
@media only screen and (max-width: 660px) {
    left: 80%;
    top: 80%;
}
@media only screen and (max-width: 420px) {
    left: 82%;
    top: 88%;
}
`
